<template>
  <div class="contentbox">
    <div class="toptitle">
        <span class="return">
          <router-link tag="span" to="/">&lt;</router-link>
        </span>
        注册
    </div>
    <div class="contenttitle">
      <p>
        <span class="font20">Hi,</span>
        <span>Welcome to Cutain World</span>
      </p>
      <p>欢迎来到家居窗帘平台</p>
    </div>
    <div class="registerbox">
      <!--<div class="register">-->
        <!--<img src="../assets/images/com.png" alt="">-->
        <!--<input type="text" placeholder="输入企业名称">-->
      <!--</div>-->
      <!--<div class="register">-->
        <!--<img src="../assets/images/user.png" alt="">-->
        <!--<input type="text" placeholder="用户名称">-->
      <!--</div>-->
      <div class="register address">
        <p>+ {{$store.state.phoneCode}}</p>
        <router-link class="minbut" tag="span" to="/selectareacode">切换地区</router-link>
      </div>
      <div class="register">
        <img src="../assets/images/phone.png" alt="">
        <input v-model="$store.state.loginphone" type="number" placeholder="手机号码">
      </div>
      <div class="register">
        <img src="../assets/images/code.png" alt="">
        <input v-model="valuecode" type="number" placeholder="填写验证码">
        <span @click="getvalcode" class="minbut">{{valuecodemeassage}}</span>
      </div>
      <div class="register">
        <img src="../assets/images/password.png" alt="">
        <input v-model="password" type="password" placeholder="填写密码">
      </div>
    </div>
    <div class="butbox">
      <div @click="submission" class="but">确认注册</div>
      <div class="other">
        <span>您注册是表示同意</span>
        <span class="red">《窗帘用户协议》</span>
      </div>
    </div>
  </div>

</template>

<script>
  import { MessageBox } from 'mint-ui';
  import {getCode,checkuser,register} from '../assets/js/api'
    export default {
        name: "register",
        data(){
          return {
            valuecodemeassage:'验证码',
            phone:'',
            valuecode:'',
            password:''
          }
        },
        components:{
          MessageBox
        },
        mounted(){
          if (this.$store.state.phoneCode === ''){
            getCode().then((data)=>{
              this.$store.commit('set_phoneCode',data.map(itme=>itme.region_num)[0])
            })
          }
        },
        methods:{
          getvalcode(){
            if (this.$store.state.loginphone === ''){
              MessageBox({
                title: '提示',
                showCancelButton: false,
                message: '请填写手机号码',
                confirmButtonText:"确定",
              })
              return
            }
            if (this.valuecodemeassage !== '验证码') return
            checkuser(this.$store.state.loginphone,this.$store.state.phoneCode).then(data=>{
              MessageBox({
                title: '提示',
                showCancelButton: false,
                message:  data.message,
                confirmButtonText:"确定",
              })
              if (data.status && data.message==='成功发送短信验证码'){
                let i=60;
                let setIntervalid = setInterval(()=>{
                  this.valuecodemeassage = '('+i+')s'
                  i--;
                  if (i===0) {
                    clearInterval(setIntervalid)
                    this.valuecodemeassage = '验证码'
                  }
                },1000)
              }
            }).catch(ree=>{
              MessageBox({
                title: '提示',
                showCancelButton: false,
                message:  ree.message,
                confirmButtonText:"确定",
              })
            })
          },
          submission(){
            let state = true
            let message = ''
            if (this.$store.state.loginphone === ''){
              message='请填写手机号码'
              state = false
            }
            else if (this.valuecode === ''){
              message='请填写验证码'
              state = false
            }
            else if (this.password === ''){
              message='请填写密码'
              state = false
            }
            if (state) {
              let registerdata={
                user:this.$store.state.loginphone,
                areaCode:this.$store.state.phoneCode,
                password:this.password,
                code:this.valuecode,
              }
              register(registerdata).then(data=>{
                MessageBox({
                  title: '提示',
                  showCancelButton: false,
                  message: data.message,
                  confirmButtonText:"确定",
                }).then(res=>{
                  if (data.status) {
                    this.$router.push({ path: '/login'});
                  }
                })
              })
            }
            else {
              MessageBox({
                title: '提示',
                showCancelButton: false,
                message: message,
                confirmButtonText:"确定",
              })
            }
          }
        }
    }
</script>

<style scoped lang="less">
  @import "../assets/less/base";
  .contentbox {
    width: 100%;
    .toptitle{
      background-color: @maincolor;
      height: 52px;
      font-size: 16px;
      line-height: 52px;
      color: #fff;
      box-shadow: 0px 2px 5px 2px #e8e8e8;
      text-align: center;
      position: relative;
      .return{
        font-size: 40px;
        position: absolute;
        left: 0.2rem;
      }
    }
    .contenttitle{
      width: 90%;
      margin: 20px auto 60px auto;
      font-size: 18px;
      .font20{
        font-size: 30px;
      }
    }
    .registerbox{
      width: 90%;
      margin: 0 auto;
      .register{
        /*display: flex;*/
        /*justify-content: space-around;*/
        position: relative;
        margin: 20px 0;
        img{
          position: absolute;
          width: 26px;
          height: 32px;
          bottom: 10px;
        }
        input{
          border: none;
          font-size: 0.3rem;
          border-bottom: 1px solid #e8e8e8;
          width: 85%;
          /*margin-left: 10%;*/
          padding-left: 15%;
          height: 36px;
          &:focus{
            border-color: #22bb61;
          }
          &::placeholder{
            color: #7c7c7c;
          }
        }
        .minbut{
          display: block;
          padding: 5px 10px;
          position: absolute;
          border: 1px solid #979797;
          border-radius: 23px;
          right: 0;
          top: 0;
        }
      }
      .address{
        display: flex;
        align-items: center;
        height: 26px;
        padding-bottom: 10px;
        border-bottom: 1px solid #e8e8e8;
        p{
          font-size: 0.3rem;
          width: 100%;
          padding-left: 0;
        }
      }
    }
    .butbox{
      width: 80%;
      margin: 0 auto;
      .but{
        text-align: center;
        padding: 16px 0;
        background-color: #979797;
        color: #353535;
        border-radius: 5px;
        margin-bottom: 20px;
      }
      .other{
        .red{
          color: #ef3f46;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/register.vue